export default __webpack_public_path__ + "static/media/light-bulb1.cfe1cea8.jpeg";